import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component, isValidElement, useEffect } from 'react';
import styled from 'styled-components';
import { H5 } from 'syf-component-library/ui/typography';
import { spacing } from 'syf-component-library/defaultTheme';
import query from 'syf-component-library/const/mediaQueries';
import { t } from '../../translations/getTranslation';
import { Paragraph } from '../../components/Styled/typography';
import ModalImage from '../../components/ModalImage';
import { ReplacementCardOnlineChatButton } from '../../components/Button';
import useSteps from '../../context/steps.context';
const ImageWrapper = styled.div `
  margin: ${({ theme }) => `${theme.spacing.xxlarge}px auto ${spacing.large}px auto;`};
  display: flex;
  justify-content: center;

  @media ${query.greaterThanMedium} {
    margin: ${({ theme }) => `${theme.spacing.xxlarge}px auto ${theme.spacing.xlarge}px auto;`};
  }
`;
const Title = styled(H5) `
  font-size: ${({ theme }) => theme.fontSizes.root}px;
  margin: 0 auto;
  text-align: center;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;
const Container = styled.div `
  padding: 0 ${({ theme }) => theme.spacing.base}px;
  @media ${query.greaterThanMedium} {
    padding: 0;
  }
`;
const DefaultFallback = () => {
    const { stepsDispatch } = useSteps();
    useEffect(() => {
        stepsDispatch({
            type: 'updateStep',
            payload: 'APIError'
        });
    }, [stepsDispatch]);
    return (_jsxs(Container, { children: [_jsx(ImageWrapper, { children: _jsx(ModalImage, { imageName: "API_ERROR" }) }), _jsx(Title, { children: t('errorBoundary.title') }), _jsxs(Paragraph, { children: [t('errorBoundary.pleaseTryAgain'), " ", _jsx(ReplacementCardOnlineChatButton, {}), "."] })] }));
};
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: undefined, hasError: false };
    }
    componentDidCatch(error, errorInfo) {
        // upd state and log out to the console afterwards
        this.setState({
            error,
            hasError: true
        }, () => {
            // eslint-disable-next-line no-console
            console.error(`Error is:\n${error}\n---\nError info:\n${errorInfo}`); // nosonar
        });
    }
    render() {
        const { hasError, error } = this.state;
        const { children, fallback } = this.props;
        const hasCustomFallback = isValidElement(fallback);
        // show error if we have it
        if (hasError) {
            // show custom fallback if it's valid
            if (hasCustomFallback) {
                return React.cloneElement(fallback, {
                    error
                });
            }
            // otherwise, show a default fallback
            return _jsx(DefaultFallback, {});
        }
        // otherwise, if no error, show children
        return children;
    }
}
export default ErrorBoundary;
//# sourceMappingURL=index.js.map